<template lang="pug">
  .msns-links
    .semibold.msns-links__title Сведения о привязанных к источнику образования местах (площадках) накопления ТКО
    ul.reset-list.msns-links__list
      li.msns-links__item(v-for="item in items" :key="item.id")
        button.button.reset-btn.msns-links__link(@click="linkToMsns(item.id)") {{ item.name }}
</template>

<script>
import url from '@/utils/url'

export default {
  name: 'msns-links',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    linkToMsns(id) {
      const name = 'msn.withContainers.update'
      let params = { id }
      let query = {}
      query.prevRoute = url.getRoute(this.$router.history.current, true)
      let route = {
        name: name,
        params: params,
        query: query,
      }
      this.$router.push(route)
    },
  },
}
</script>
